module.exports = __webpack_public_path__ + "static/img/help1.3403893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/help1.png
// module id = uOvX
// module chunks = 1